// extracted by mini-css-extract-plugin
export default {"root":"styles_root__XI98x","previewContainer":"styles_previewContainer__S8UJW"};